import { render, staticRenderFns } from "./import-file.vue?vue&type=template&id=5b027f06"
import script from "./import-file.vue?vue&type=script&lang=js"
export * from "./import-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports